import * as actions from './actions'

const initialState = {
  stories: {
    isFetching: false,
    error: null,
    data: [],
    lastFetched: null,
    filterQuery: '',
    reversed: false,
  },
  currentStory: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  newStory: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  updateStory: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  deleteStory: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  currentStoryCards: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  deleteStoryCard: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  updatedStoryCard: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
  exportStory: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null,
  },
}

export default function storiesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.FETCH_STORIES_LOADING: {
      return {
        ...state,
        stories: {
          ...state.stories,
          isFetching: true,
          error: null,
        },
      }
    }
    case actions.FETCH_STORIES_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        stories: {
          ...state.stories,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null,
        },
      }
    }
    case actions.FETCH_STORIES_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        stories: {
          ...state.stories,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.SET_STORY_LIST_FILTER: {
      return {
        ...state,
        stories: {
          ...state.stories,
          filterQuery: action.filterQuery,
        },
      }
    }
    case actions.SET_STORY_LIST_REVERSED: {
      return {
        ...state,
        stories: {
          ...state.stories,
          reversed: action.isReversed ?? !state.stories.reversed,
        },
      }
    }
    case actions.FETCH_STORY_LOADING: {
      return {
        ...state,
        currentStory: {
          ...state.currentStory,
          isFetching: true,
          error: null,
        },
      }
    }
    case actions.FETCH_STORY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStory: {
          ...state.currentStory,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null,
        },
      }
    }
    case actions.FETCH_STORY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStory: {
          ...state.currentStory,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.CREATE_STORY_LOADING: {
      return {
        ...state,
        newStory: {
          ...state.newStory,
          isFetching: true,
          error: null,
          data: null,
        },
      }
    }
    case actions.CREATE_STORY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        stories: {
          ...state.stories,
          lastFetched,
          data: state.stories.data ? state.stories.data.concat([action.payload]) : [action.payload],
        },
        newStory: {
          ...state.newStory,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null,
        },
      }
    }
    case actions.CREATE_STORY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        newStory: {
          ...state.newStory,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.UPDATE_STORY_LOADING: {
      return {
        ...state,
        updateStory: {
          ...state.updateStory,
          isFetching: true,
          error: null,
          data: null,
        },
      }
    }
    case actions.UPDATE_STORY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        updateStory: {
          ...state.updateStory,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null,
        },
      }
    }
    case actions.UPDATE_STORY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        updateStory: {
          ...state.updateStory,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.DELETE_STORY_LOADING: {
      return {
        ...state,
        deleteStory: {
          ...state.deleteStory,
          isFetching: true,
          error: null,
          data: action.payload,
        },
      }
    }
    case actions.DELETE_STORY_SUCCESS: {
      const lastFetched = Date.now()

      let newStories
      if (state.stories.data && state.deleteStory.data && state.deleteStory.data.id) {
        newStories = state.stories.data.filter(file => {
          if (state.deleteStory.data && state.deleteStory.data.id) {
            return file.id !== state.deleteStory.data.id
          }
          return true
        })
      }

      return {
        ...state,
        stories: {
          ...state.stories,
          lastFetched,
          data: newStories || state.stories.data,
        },
        deleteStory: {
          ...state.deleteStory,
          isFetching: false,
          lastFetched,
          data: null,
          error: null,
        },
      }
    }
    case actions.DELETE_STORY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        deleteStory: {
          ...state.deleteStory,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.FETCH_STORY_CARDS_LOADING: {
      return {
        ...state,
        currentStoryCards: {
          ...state.currentStoryCards,
          isFetching: true,
          error: null,
          data: null,
        },
      }
    }
    case actions.FETCH_STORY_CARDS_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStoryCards: {
          ...state.currentStoryCards,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null,
        },
      }
    }
    case actions.FETCH_STORY_CARDS_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentStoryCards: {
          ...state.currentStoryCards,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.DELETE_STORY_CARD_LOADING: {
      return {
        ...state,
        deleteStoryCard: {
          ...state.deleteStoryCard,
          isFetching: true,
          error: null,
          data: null,
        },
      }
    }
    case actions.DELETE_STORY_CARD_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        deleteStoryCard: {
          ...state.deleteStoryCard,
          isFetching: false,
          lastFetched,
          data: null,
          error: null,
        },
      }
    }
    case actions.DELETE_STORY_CARD_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        deleteStoryCard: {
          ...state.deleteStoryCard,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.UPDATE_STORY_CARD_LOADING: {
      return {
        ...state,
        updatedStoryCard: {
          ...state.updatedStoryCard,
          isFetching: true,
          error: null,
          data: null,
        },
      }
    }
    case actions.UPDATE_STORY_CARD_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        updatedStoryCard: {
          ...state.updatedStoryCard,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null,
        },
      }
    }
    case actions.UPDATE_STORY_CARD_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        updatedStoryCard: {
          ...state.updatedStoryCard,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    case actions.EXPORT_STORY_LOADING: {
      return {
        ...state,
        exportStory: {
          ...state.exportStory,
          isFetching: true,
          error: null,
          data: null,
        },
      }
    }
    case actions.EXPORT_STORY_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        exportStory: {
          ...state.exportStory,
          isFetching: false,
          lastFetched,
          data: null,
          error: null,
        },
      }
    }
    case actions.EXPORT_STORY_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        exportStory: {
          ...state.exportStory,
          isFetching: false,
          lastFetched,
          error: action.payload,
        },
      }
    }
    default:
      return state
  }
}
